__turbopack_context__.v({
  "accentBar": "DiscoveryAccordionBlock-module__wBUbyG__accentBar",
  "accentBarAnimating": "DiscoveryAccordionBlock-module__wBUbyG__accentBarAnimating",
  "accentBarFilled": "DiscoveryAccordionBlock-module__wBUbyG__accentBarFilled",
  "accordionAccentFill": "DiscoveryAccordionBlock-module__wBUbyG__accordionAccentFill",
  "accordionContent": "DiscoveryAccordionBlock-module__wBUbyG__accordionContent",
  "accordionControl": "DiscoveryAccordionBlock-module__wBUbyG__accordionControl",
  "accordionItem": "DiscoveryAccordionBlock-module__wBUbyG__accordionItem",
  "accordionItemOpen": "DiscoveryAccordionBlock-module__wBUbyG__accordionItemOpen",
  "accordionLabel": "DiscoveryAccordionBlock-module__wBUbyG__accordionLabel",
  "accordionPanel": "DiscoveryAccordionBlock-module__wBUbyG__accordionPanel",
  "accordionRoot": "DiscoveryAccordionBlock-module__wBUbyG__accordionRoot",
  "chevron": "DiscoveryAccordionBlock-module__wBUbyG__chevron",
  "controlInner": "DiscoveryAccordionBlock-module__wBUbyG__controlInner",
  "eyebrow": "DiscoveryAccordionBlock-module__wBUbyG__eyebrow",
  "header": "DiscoveryAccordionBlock-module__wBUbyG__header",
  "inlineMedia": "DiscoveryAccordionBlock-module__wBUbyG__inlineMedia",
  "itemBody": "DiscoveryAccordionBlock-module__wBUbyG__itemBody",
  "itemTitle": "DiscoveryAccordionBlock-module__wBUbyG__itemTitle",
  "itemTitleCompact": "DiscoveryAccordionBlock-module__wBUbyG__itemTitleCompact",
  "itemTitleDesktop": "DiscoveryAccordionBlock-module__wBUbyG__itemTitleDesktop",
  "mediaFrame": "DiscoveryAccordionBlock-module__wBUbyG__mediaFrame",
  "mediaImage": "DiscoveryAccordionBlock-module__wBUbyG__mediaImage",
  "mediaVideo": "DiscoveryAccordionBlock-module__wBUbyG__mediaVideo",
  "panel": "DiscoveryAccordionBlock-module__wBUbyG__panel",
  "section": "DiscoveryAccordionBlock-module__wBUbyG__section",
  "sideMedia": "DiscoveryAccordionBlock-module__wBUbyG__sideMedia",
  "title": "DiscoveryAccordionBlock-module__wBUbyG__title",
  "titleDesktop": "DiscoveryAccordionBlock-module__wBUbyG__titleDesktop",
  "titleMobile": "DiscoveryAccordionBlock-module__wBUbyG__titleMobile",
  "titleTablet": "DiscoveryAccordionBlock-module__wBUbyG__titleTablet",
});
